<template>

 <div>
    <nav v-show="this.$route.name === 'home'"  class="navbar navbar-expand-lg p-0 m-0 py-3">
        <div>
              <img :src="`${publicPath}img/RocaGroupMemoriaAnual2021${locale}.svg`" class="svg svg-logo">
        </div>
        <div class="position-absolute top-5 top-lg-0 end-0 justify-content-end">
            <div class="row align-items-center row-cols-auto idiomes p-0 mx-0 pe-0 pe-lg-5 ms-0 ms-lg-5">
                <div class="col text-center lang">
                    <a :href="`${publicPath}es/`" :class="isEs ? 'router-active-language' : ''">
                        CAS
                    </a>
                </div>
                <div class="col text-center lang">
                    <a :href="`${publicPath}en/`" :class="isEn ? 'router-active-language' : ''">
                        ENG
                    </a>
                </div>
                <div class="col text-end lang p-0">
                    <download-file
                        title="Descargar<br>memoria"
                        :showtitle="false"
                        :file= download_file
                        class="justify-content-end" />
                </div>
            </div>
        </div>

    </nav>

    <nav  v-show="this.$route.name !== 'home'"  class="navbar navbar-expand-lg p-0 m-0 mb-xs-5">
        <div class="container-fluid d-xs-block d-sm-block d-md-block d-lg-none bocata">
            <div class="row align-items-center">
                <div class="col-xs-6 col-6 logoRoca">
                    <localized-link to="/">
                        <img :src="`${publicPath}img/RocaGroupMemoriaAnual2021${locale}.svg`" height="100">
                    </localized-link>
                </div>
                <div class="col-xs-6 col-6 text-end pe-4">
                    <a class="" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                        <i class="fa fa-2x fa-bars"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="collapse navbar-collapse pe-3" id="collapseExample">
            <ul class="navbar-nav align-items-start g-0">
                <li class="col nav-item text-center d-none d-lg-block d-xl-block d-xxl-block">
                    <localized-link to="/">
                        <img :src="`${publicPath}img/RocaGroupMemoriaAnual2021${locale}.svg`" width="180">
                    </localized-link>
                </li>
                <li class="col nav-item text-center d-xs-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none mt-3 align-top">
                  <localized-link class="nav-link" to="/"  data-target="/">Home</localized-link>
                </li>
                <li class="col nav-item text-center dropdown">
                  <localized-link class="nav-link align-top" to="/roca-group-2021"  data-target="/roca-group-2021">{{ $t("nav.roca_group_2021") }}</localized-link>
                    <ul class="dropdown-menu">
                      <li><localized-link class="dropdown-item ps-4" to="/roca-group-2021/presentacion">{{ $t("nav.presentacion") }}</localized-link></li>
                      <li><localized-link class="dropdown-item ps-4" to="/roca-group-2021/2021-en-resumen">{{ $t("nav.resumen") }}</localized-link></li>
                      <li><localized-link class="dropdown-item ps-4" to="/roca-group-2021/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link></li>
                    </ul>
                </li>
                <li class="col nav-item text-center dropdown">
                  <localized-link class="nav-link align-top" to="/avanzando-hacia-el-futuro"  data-target="/avanzando-hacia-el-futuro">{{ $t("nav.avanzando") }}</localized-link>
                    <ul class="dropdown-menu">
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></li>
                    </ul>
                </li>
                <li class="col nav-item text-center dropdown">
                  <localized-link class="nav-link align-top" to="/fundacion-we-are-water"  data-target="/we-are-water" v-html="$t('nav.we-are-water')"></localized-link>
                    <ul class="dropdown-menu ">
                        <li><localized-link class="dropdown-item ps-4" to="/fundacion-we-are-water/proyectos-de-cooperacion">{{ $t("nav.proyectos-de-cooperacion") }}</localized-link></li>
                        <li><localized-link class="dropdown-item ps-4" to="/fundacion-we-are-water/acciones-de-concienciacion">{{ $t("nav.acciones-de-concienciacion") }}</localized-link></li>
                    </ul>
                </li>
                <li class="col nav-item text-center">
                  <localized-link class="nav-link align-top" to="/informe-financiero">{{ $t("nav.informe-financero") }}</localized-link>
                </li>
                <li class="col nav-item col-md-auto text-center">
                    <language-switcher class="row justify-content-end " v-slot="{ links }" tag="div">
                        <div v-for="link in links.slice().reverse()" :key="link.langIndex"
                                class="col-3 col-md-2 col-lg-6 text-center px-0 align-top">
                            <a  :class="link.activeClass"
                                :href="`${publicPath}${link.url.substring(1)}`"
                                class="nav-link text-center"
                            ><div v-if="link.langIndex=='es'">CAS</div><div v-if="link.langIndex=='en'">ENG</div></a>
                        </div>
                    </language-switcher>
                </li>
                <li class="col nav-item col-md-auto pb-xs-5" style="border-bottom: none">
                    <download-file  v-if="locale === 'es'"
                        title="Descargar<br>memoria"
                        :showtitle="true"
                        :file="download_file"
                        class="nav-link text-end menuDownload justify-content-end" />
                    <download-file v-if="locale==='en'"
                                   title="Download<br>report"
                                   :showtitle="true"
                                   :file="download_file"
                                   class="nav-link text-end menuDownload justify-content-end" />
                </li>
            </ul>
            <p>&nbsp;</p>
        </div> <!-- navbar-collapse.// -->
    </nav>

 </div>
</template>

<script>
    import DownloadFile from "@/components/DownloadFile";
    export default {
        name: "NavigationView",
        components: {
            DownloadFile
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                isEs:true,
                isEn: false,
                locale:this.$i18n.locale,
                backgroundUrl:'@/img/RocaGroupMemoriaAnual2021es.svg',
                download_file:'ROCA_GROUP_Memoria_Anual_2021_site.pdf'
            }
        },
        created() {
            // Remove show class from collapsible element to close movile menu
            this.$router.afterEach(() => {
                var element = document.getElementById("collapseExample");
                element.classList.remove("show");
                this.isEs = this.$i18n.locale=="es" ? true : false;
                this.isEn = this.$i18n.locale=="en" ? true : false;
                this.locale = this.$i18n.locale;
                if(this.isEn){
                  this.backgroundUrl = '@/img/RocaGroupMemoriaAnual2021en.svg';
                  this.download_file = 'ROCA_GROUP_Annual_Report_2021_site.pdf';
                }
            });
        },
    };
</script>

